var map = {
	"./541d2506-9363-4c8b-8646-cfbf6fa7031e.pdf": 2029,
	"./573775ba-db66-4d5c-823f-09dfa78db616.pdf": 2030,
	"./6e063bce-ead8-43d7-9bc6-4e322be4e885.pdf": 2031,
	"./COLA2018001.pdf": 2032,
	"./COLA2018002.pdf": 2033,
	"./COLA2018003.pdf": 2034,
	"./COLA2018004.pdf": 2035,
	"./COLA2018005.pdf": 2036,
	"./COLA2018006.pdf": 2037,
	"./COLA2018007.pdf": 2038,
	"./COLA2018008.pdf": 2039,
	"./Chapter.pdf": 2040,
	"./c7da8588-5302-43fa-9200-368b6ba96eba.pdf": 2041,
	"./doc.pdf": 2042
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2028;


//////////////////
// WEBPACK FOOTER
// ./src/PDFFiles ^\.\/.*$
// module id = 2028
// module chunks = 1